import Immutable from 'seamless-immutable';
import _ from 'lodash';
import DataSourceModel from './data-source-model';

/**
 * Transforms an array of backend integration objects into a IntegrationCollection
 * @param {Object[]} integrations - backend formatted integrations
 * @returns {Integration[]}
 */
function deserialize(dropdownData = []) {
  return Immutable(_.map(dropdownData, DataSourceModel.deserialize));
}

/**
 * Transforms an IntegrationCollection into an array of backend integration objects
 * @param {Integration[]} integrations
 * @returns {Object[]}
 */
function serialize(dropdownData) {
  return _.map(dropdownData, (data) => DataSourceModel.serialize(data));
}

export default {
  create: deserialize,
  deserialize,
  serialize,
};
